import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export type AVQuality = 'normal' | 'medium' | 'high'

export class VideoOptionsVM extends CommonOptionVM {
  allow_camera?: boolean
  photo_library?: boolean
  quality?: AVQuality
  max_length?: number

  constructor(data: Partial<VideoOptionsVM> = {}) {
    super(data)
    this.allow_camera = data?.allow_camera ?? undefined
    this.photo_library = data?.photo_library ?? undefined
    this.quality = data?.quality ?? undefined
    this.max_length = data?.max_length ?? undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default VideoOptionsVM